/**
 * juliette-relance-instructions — Instructions de rédaction calibrées par type
 * de signal, pour la pré-rédaction de relance en 1 clic (Phase 4 #3 v1).
 *
 * Quand l'agent clique « Préparer la relance » sur un signal, on passe ces
 * instructions à generate-relance-email pour orienter le ton selon le contexte
 * du signal. Pur (testable), aucune dépendance.
 *
 * Renvoie null pour les signaux NON éligibles (dormant, inconnus) → pas de
 * bouton « Préparer la relance ».
 */

const RELANCE_INSTRUCTIONS: Record<string, string> = {
  hot_blocked:
    "Lead chaud resté sans réponse depuis quelques jours. Ton chaleureux et " +
    "engageant, propose une prochaine étape concrète (un appel ou une visite), " +
    "sans mettre la pression.",
  mandate_expiring:
    "Le mandat de ce contact arrive à échéance. Propose un point de situation " +
    "et la reconduction du mandat, sur un ton posé et rassurant, sans pression.",
  to_triage:
    "Contact sans nouvelles depuis 1 à 3 mois. Relance légère, chaleureuse et " +
    "sans pression, pour reprendre contact et savoir où en est son projet.",
};

/** Instructions de relance pour un type de signal, ou null si non éligible. */
export function relanceInstructionsForSignal(signalType: string): string | null {
  return RELANCE_INSTRUCTIONS[signalType] ?? null;
}

/** Vrai si ce type de signal peut donner lieu à une pré-rédaction de relance. */
export function canPrepareRelance(signalType: string): boolean {
  return relanceInstructionsForSignal(signalType) !== null;
}
